/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import appTheme from '../theme/appTheme.json';
import NotificationBadge from '../layout/header/NotificationBadge';

export interface WhatsNewBadgeIconProps {
  showBadge: boolean;
}

const WhatsNewBadgeIcon: React.FC<WhatsNewBadgeIconProps> = ({ showBadge }) => {
  return (
    <NotificationBadge showBadge={showBadge}>
      <NewReleasesIcon
        sx={{
          fontSize: 24,
          color: appTheme.secondaryHeaderTextColor,
        }}
      />
    </NotificationBadge>
  );
};

export default WhatsNewBadgeIcon;
